<script lang="ts" module>
	export const symbolFilledId = "ishavskraft-icon-heart-filled";
	export const symbolOutlineId = "ishavskraft-icon-heart-outline";
	export const symbol = `
		<symbol id="${symbolFilledId}" viewBox="0 0 14 12">
			<path d="M6.66667 11.7833C6.51111 11.7833 6.35289 11.7556 6.192 11.7C6.03111 11.6444 5.88933 11.5556 5.76667 11.4333L4.61667 10.3833C3.43889 9.30556 2.37489 8.23622 1.42467 7.17533C0.474445 6.11444 -0.000444133 4.94489 3.11672e-07 3.66667C3.11672e-07 2.62222 0.35 1.75 1.05 1.05C1.75 0.35 2.62222 0 3.66667 0C4.25556 0 4.81111 0.124889 5.33333 0.374667C5.85556 0.624444 6.3 0.966222 6.66667 1.4C7.03333 0.966667 7.47778 0.625111 8 0.375333C8.52222 0.125556 9.07778 0.000444444 9.66667 0C10.7111 0 11.5833 0.35 12.2833 1.05C12.9833 1.75 13.3333 2.62222 13.3333 3.66667C13.3333 4.94444 12.8611 6.11667 11.9167 7.18333C10.9722 8.25 9.9 9.32222 8.7 10.4L7.56667 11.4333C7.44444 11.5556 7.30289 11.6444 7.142 11.7C6.98111 11.7556 6.82267 11.7833 6.66667 11.7833Z" />
		</symbol>
		<symbol id="${symbolOutlineId}" viewBox="0 0 16 16">
			<path d="M7.99992 13.5499C7.84436 13.5499 7.68614 13.5222 7.52525 13.4666C7.36436 13.411 7.22258 13.3222 7.09992 13.1999L5.94992 12.1499C4.77214 11.0722 3.70814 10.0028 2.75792 8.94193C1.8077 7.88105 1.33281 6.71149 1.33325 5.43327C1.33325 4.38882 1.68325 3.5166 2.38325 2.8166C3.08325 2.1166 3.95547 1.7666 4.99992 1.7666C5.58881 1.7666 6.14436 1.89149 6.66658 2.14127C7.18881 2.39105 7.63325 2.73282 7.99992 3.1666C8.36658 2.73327 8.81103 2.39171 9.33325 2.14193C9.85547 1.89216 10.411 1.76705 10.9999 1.7666C12.0444 1.7666 12.9166 2.1166 13.6166 2.8166C14.3166 3.5166 14.6666 4.38882 14.6666 5.43327C14.6666 6.71105 14.1944 7.88327 13.2499 8.94993C12.3055 10.0166 11.2333 11.0888 10.0333 12.1666L8.89992 13.1999C8.7777 13.3222 8.63614 13.411 8.47525 13.4666C8.31436 13.5222 8.15592 13.5499 7.99992 13.5499ZM7.36659 4.49993C7.04436 4.04438 6.69992 3.69705 6.33325 3.45793C5.96659 3.21882 5.52214 3.09949 4.99992 3.09993C4.33325 3.09993 3.7777 3.32216 3.33325 3.7666C2.88881 4.21105 2.66659 4.7666 2.66659 5.43327C2.66659 6.01105 2.87214 6.62505 3.28325 7.27527C3.69436 7.92549 4.18614 8.55593 4.75859 9.1666C5.33103 9.77727 5.91992 10.3495 6.52525 10.8833C7.13059 11.417 7.62214 11.8559 7.99992 12.1999C8.3777 11.8555 8.86947 11.4166 9.47525 10.8833C10.081 10.3499 10.6699 9.77771 11.2419 9.1666C11.8139 8.55549 12.3055 7.92505 12.7166 7.27527C13.1277 6.62549 13.3333 6.01149 13.3333 5.43327C13.3333 4.7666 13.111 4.21105 12.6666 3.7666C12.2221 3.32216 11.6666 3.09993 10.9999 3.09993C10.4777 3.09993 10.0333 3.21949 9.66658 3.4586C9.29992 3.69771 8.95547 4.04482 8.63325 4.49993C8.55547 4.61105 8.46103 4.69438 8.34992 4.74993C8.23881 4.80549 8.12214 4.83327 7.99992 4.83327C7.8777 4.83327 7.76103 4.80549 7.64992 4.74993C7.53881 4.69438 7.44436 4.61105 7.36659 4.49993Z" />
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		filled = false,
		class: classes = null,
		ariaHidden = true,
	}: {
		filled?: boolean;
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

{#if filled}
	<svg
		aria-hidden={ariaHidden}
		width="14"
		height="12"
		viewBox="0 0 14 12"
		xmlns="http://www.w3.org/2000/svg"
		class={classes}
		fill="currentColor"
	>
		<use href="#{symbolFilledId}" />
	</svg>
{:else}
	<svg
		aria-hidden={ariaHidden}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		class={classes}
		fill="currentColor"
	>
		<use href="#{symbolOutlineId}" />
	</svg>
{/if}
